import { Wrapper } from 'AppReact';
import styled from 'styled-components';

export default Wrapper(styled.div`
    display: flex; 
    align-items: center; 
    overflow: auto; 

    scrollbar-width: none;
    scrollbar-color: white white;
    /* width */
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
`)
